import parseISO from '@teetsh/app/src/utils/time/parseISO';
import {
  LabelledDateRange,
  LabelledDateRangeApi,
  Zone,
  ZoneApi,
} from '@teetsh/app/src/types/zone';
import formatISO from '@teetsh/app/src/utils/time/formatISO';
import deserializeDateFromServer from '@teetsh/app/src/utils/time/deserializeDateFromServer';
import serializeDateToServer from '@teetsh/app/src/utils/time/serializeDateToServer';

export function serializeLabelledDateRange(
  lRange: LabelledDateRange,
  tz: string,
): LabelledDateRangeApi {
  let res: LabelledDateRangeApi = {
    id: lRange.id,
    label: lRange.label,
  };
  if (lRange.from) {
    res = {
      ...res,
      from: formatISO(serializeDateToServer(lRange.from, tz)),
    };
  }
  if (lRange.to) {
    res = {
      ...res,
      to: formatISO(serializeDateToServer(lRange.to, tz)),
    };
  }
  if (lRange.color) {
    res = {
      ...res,
      color: lRange.color,
    };
  }
  return res;
}

export function deserializeLabelledDateRange(
  lRange: LabelledDateRangeApi,
  tz: string,
): LabelledDateRange {
  let res: LabelledDateRange = {
    id: lRange.id,
    label: lRange.label,
  };
  if (lRange.from) {
    res = {
      ...res,
      from: deserializeDateFromServer(parseISO(lRange.from), tz),
    };
  }
  if (lRange.to) {
    res = {
      ...res,
      to: deserializeDateFromServer(parseISO(lRange.to), tz),
    };
  }
  if (lRange.color) {
    res = {
      ...res,
      color: lRange.color,
    };
  }
  return res;
}

export function deserializeZone(tz: string, zone?: ZoneApi): Zone | undefined {
  if (!zone) {
    return undefined;
  }
  return {
    ...zone,
    holidays: (zone.holidays || []).map(h =>
      deserializeLabelledDateRange(h, tz),
    ),
    periodes: (zone.periodes || []).map(h =>
      deserializeLabelledDateRange(h, tz),
    ),
  };
}

export function serializeZone(
  zone: Zone | undefined,
  tz: string,
): ZoneApi | undefined {
  if (!zone) {
    return undefined;
  }
  return {
    ...zone,
    holidays: (zone.holidays || []).map(h => serializeLabelledDateRange(h, tz)),
    periodes: (zone.periodes || []).map(h => serializeLabelledDateRange(h, tz)),
  };
}
